<div v-if="values.length > 0" class="tt-c-summary-dim tt-c-summary-dim-select tt-u-spacing--sm">
  <div class="tt-c-summary-dim__heading tt-u-align-center" role="heading" :aria-level="headingLevel">{{dim.label}}</div>
  <div class="tt-c-summary-dim__text tt-u-align-center tt-u-spacing--left--xs">
    <template v-if="dimFiltersOn">
      <tt-button v-for="val in values"
                type="link"
                class="tt-c-summary-dim-select__link"
                @click="filterBy(val)"
                :aria-label="$msg('summarySelect.showReviews', [dim.label, val.label])"
                >{{val.label}} ({{val.count}})</tt-button>
    </template>
    <template v-else>{{valuesAsText}}</template>
  </div>
</div>
